<div class="empty-state">
  <div class="img-container top-image" *ngIf="!collection">
    <u-icon [model]="{ type: 'img', value: emptyStateIcon }" [styles]="{}" [inSvg]="emptyStateIcon?.lightUrl"></u-icon>
  </div>
  <div class="title">{{ wikiContent.wikiEmptyStateTitle1 }}</div>
  <div class="sub-title">
    {{ wikiContent.wikiEmptyStateSubtitle1 }}
    <br />
    {{ wikiContent.wikiEmptyStateSubtitle2 }}
    <br />
    {{ wikiContent.wikiEmptyStateSubtitle3 }}
    <u-button type="link" [label]="wikiContent.learnMore" (onClick)="openLearnMore()"></u-button>
  </div>

  <div class="btn-wrapper">
    <u-button
      *ngIf="!collection || (collection && canEdit)"
      [label]="wikiContent.wikiEmptyStateBtnText"
      (onClick)="createNewWiki()"
      [typeElement]="'primary'"
      [versionNumber]="2"
    ></u-button>
  </div>
</div>
